import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { reduxForm, formValueSelector } from 'redux-form';
import partial from 'lodash/partial';
import idx from 'idx';
import { DEFAULT_REQUIRED_MESSAGE, REQUIRED_COLOR_MESSAGE } from 'common/components/form_fields';
import { update } from 'presentations/ducks';
import { EDIT_FORM_NAME } from 'presentations/constants';
import { validateSubDomain, getVoteStats } from 'presentations/utils';
import Settings from 'presentations/components/settings';

const mapStateToProps = (state) => {
  const presentation = state.project.presentations.currentPresentation;
  const participants = idx(state, _ => _.project.presentations.currentParticipants) || [];
  const revisions = idx(state, _ => _.project.presentations.currentRevisions) || [];

  /* get value of `permissions` field based on presentation attributes */
  let permissions = 'nothing';
  if (presentation.allow_voting) {
    permissions = 'voting';
  }
  if (presentation.allow_comments) {
    if (presentation.allow_voting) {
      permissions += '_and_comments';
    } else {
      permissions = 'comments';
    }
  }

  const initialValues = {
    ...presentation,
    permissions,
    logo: presentation.logo? { preview: presentation.logo, filename: 'Current Logo' } : null,
    use_standard_colors: !presentation.colors.primary,
    custom_primary_color: presentation.colors.primary
  };

  /* `weight_votes` can only be updated if no vote was created yet */
  const voteStats = getVoteStats({ presentation, revisions, participants });
  const canUpdateWeightVotes = voteStats.voteCount === 0;

  /* only the form values that will be used in the component */
  const selector = formValueSelector(EDIT_FORM_NAME);
  const currentValues = selector(state, 'use_standard_colors', 'custom_primary_color', 'logo', 'purpose');

  return {
    initialValues,
    canUpdateWeightVotes,
    currentValues
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const { presentationId } = params;

  return bindActionCreators({
    update: partial(update, presentationId),
  }, dispatch);
}

const validate = (values) => {
  const errors = {};
  const requiredFields = ['name', 'password', 'sub_domain', 'purpose'];
  for (let f of requiredFields) {
    if (!values[f]) errors[f] = DEFAULT_REQUIRED_MESSAGE;
  }
  if (!errors.sub_domain) {
    errors.sub_domain = validateSubDomain(values.sub_domain);
  }
  if (!values.use_standard_colors && !values.custom_primary_color) {
    errors.custom_primary_color = REQUIRED_COLOR_MESSAGE;
  }
  return errors;
}

const Form = reduxForm({
  form: EDIT_FORM_NAME,
  validate
})(Settings);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./presentations/containers/settings.js